export function isInt(n: unknown): n is number {
  return Number(n) === n && n % 1 === 0;
}
